// @todo: Add explicit entries to this list as needed after trying to use built-in Chakra theme sizes where possible.
// @todo: Consider importing all Chakra default theme values here so devs can quickly reference them, and benefit from IDE autocomplete. If doing so, clearly differentiate between default and custom values.
// @see: https://chakra-ui.com/docs/theming/theme#sizes
export const typography = {
    lineHeights: {
        11: '2.75rem',
        12: '3rem',
    },
}
